import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/images/user.svg'


const _hoisted_1 = { class: "flex justify-center items-center flex-nowrap" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "w-8 h-8 rounded rounded-full bg-moreBg overflow-hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-8 h-8",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "w-full tesx-xs font-normal text-darkText ms-2 leading-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.indicatorClass)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([_ctx.indicatorClass, "rounded rounded-full border-2 border-white w-3 h-3 absolute -top-0 -end-0 z-30"])
            }, null, 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.createDriverFullName(_ctx.driverInfo)), 1)
    ])
  ]))
}